import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/dialog';
import { MapPin } from 'lucide-react';
import { DeliveryAddress } from '@Types/purchase';

type AddressViewerDialogProps = {
  title: string;
  address: DeliveryAddress | null;
};

function formatAddress(address: DeliveryAddress): string[] {
  const lines: string[] = [];

  if (address.streetAddress1) {
    lines.push(address.streetAddress1);
  }

  if (address.streetAddress2) {
    lines.push(address.streetAddress2);
  }

  const cityStateZip: string[] = [];
  if (address.city) {
    cityStateZip.push(address.city);
  }
  if (address.state) {
    cityStateZip.push(address.state);
  }
  if (cityStateZip.length > 0) {
    let line = cityStateZip.join(', ');
    if (address.zipCode) {
      line += ` ${address.zipCode}`;
    }
    lines.push(line);
  } else if (address.zipCode) {
    lines.push(address.zipCode);
  }

  if (address.country) {
    lines.push(address.country);
  }

  return lines;
}

export default function AddressViewerDialog({
  title,
  address,
}: AddressViewerDialogProps) {
  if (!address) {
    return <span className="text-zinc-400">-</span>;
  }

  const addressLines = formatAddress(address);

  if (addressLines.length === 0) {
    return <span className="text-zinc-400">-</span>;
  }

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="gap-1">
          <MapPin className="h-4 w-4" />
          View
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <div className="rounded-md bg-zinc-50 p-4">
            {addressLines.map((line, index) => (
              <p key={index} className="text-sm text-zinc-700">
                {line}
              </p>
            ))}
          </div>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Close</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
